import { NoizuStruct } from "../noizu/structs/noizu-struct";
import { WidgetEnum } from "../enums";

export class WidgetEventStruct extends NoizuStruct {
  public event_type: String;
  public event_body: any;
  public event_widget_type: WidgetEnum;
}
